import { ElementType, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

/**
 * Container — wrapper centrado con max-width y gutter responsive.
 *
 * Usa el plugin `container` de Tailwind configurado en tailwind.config.ts,
 * que aplica padding 16px (mobile) -> 24px (lg) y centra al ancho marca
 * (`--container-max` = 1440px en `2xl`).
 *
 * Anchos opcionales: 'narrow' (max-w 720), 'default' (1440 via container).
 */
export type ContainerWidth = 'narrow' | 'default' | 'wide' | 'full';

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  width?: ContainerWidth;
  children: ReactNode;
}

const widthClasses: Record<ContainerWidth, string> = {
  narrow: 'max-w-[720px] mx-auto',
  default: 'container',
  wide: 'max-w-[1200px] mx-auto',
  full: 'max-w-none',
};

export function Container({
  as: As = 'div',
  width = 'default',
  className,
  children,
  ...rest
}: ContainerProps) {
  return (
    <As
      className={cn(
        widthClasses[width],
        // Solo aplicamos gutter manual cuando no usamos el plugin `container` de Tailwind.
        width !== 'default' && 'px-4 lg:px-6',
        className,
      )}
      {...rest}
    >
      {children}
    </As>
  );
}
